import { AIFI_LEVEL_COLORS } from '@/domains/pages/ai-proficiency/constants';
import { themeColors } from '@/theme/palette';

/**
 * Colour a segment by its score against the median of its peers. Shared by the segment
 * picker pills and the proficiency scale chart so the two always agree.
 */
export function segmentScoreColor(score: number | null, median: number): string {
  if (score == null) return themeColors.text.secondary;
  return score >= median ? AIFI_LEVEL_COLORS.Practitioner : AIFI_LEVEL_COLORS.Novice;
}
